export const PROPERTY_NODES = ["tab"];
